// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___2iqUi","btn":"btn___1QSrn","intro":"intro___qjD2R","linkBtn":"linkBtn___2w27p","mp":"mp___zVNee","tip":"tip___3Xhzk"};